import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Spin } from "antd";
import React, { useState } from "react";
import CreateScalesApi from "../../../api/scales/CreateScalesApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

function AddScaleModal(props) {
  const [submit, setSubmit] = useState(false);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await CreateScalesApi(
      values.name,
      values.unitName,
      values.abbreviation,
      values.symbol
    );

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Scales added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add scales. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Add custom scale"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="scales"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Scale name"
          name="name"
          rules={[{ required: true, message: "Please enter a scale name!" }]}
        >
          <Input placeholder="name" />
        </Form.Item>

        <Form.Item
          label="Unit"
          name="unitName"
          rules={[{ required: true, message: "Please enter a unit name!" }]}
        >
          <Input placeholder="unit" />
        </Form.Item>

        <Form.Item
          label="Symbol"
          name="symbol"
          rules={[{ required: true, message: "Please enter symbol!" }]}
        >
          <Input placeholder="symbol" />
        </Form.Item>

        <Form.Item
          label="Abbreviation"
          name="abbreviation"
          rules={[{ required: true, message: "Please enter abbreviation!" }]}
        >
          <Input placeholder="abbreviation" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddScaleModal;
